import React, { useRef } from 'react';
import { useRevisionChatCommentReplyQueryContext } from 'src/features/comments/use-request-reply-comments';
import { CommentResponse } from 'src/lib/services/api/comment-api';
import RevisionChatCommentReplySheetComments from './revision-chat-comment-reply-sheet-comments';
import { RevisionChatInputForm } from './revision-chat-input-form';
import { useRequestCommentsContext } from 'src/features/comments/use-request-comments';
import { useEditorReadOnlyAccess } from 'src/features/requests/hooks/use-editor-read-only-access';
import { EditorReadOnlyNotice } from 'src/features/requests/editor-read-only-notice';

const RevisionChatCommentReplySheetContent: React.FC<{ replyComment: CommentResponse }> = ({
  replyComment,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const { replyCommentMutation } = useRevisionChatCommentReplyQueryContext();
  const { invalidate } = useRequestCommentsContext();
  const isReadOnly = useEditorReadOnlyAccess();

  const scrollToBottom = () => {
    if (!scrollRef.current || !scrollRef.current?.scrollHeight) {
      return;
    }

    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  };

  return (
    <>
      <RevisionChatCommentReplySheetComments ref={scrollRef} replyComment={replyComment} />
      {/* A cover editor may read the thread — replying belongs to the editor
          the request is assigned to (#2653). */}
      {isReadOnly ? (
        <EditorReadOnlyNotice className={'tw-mx-6 tw-mb-6 tw-rounded-md'} />
      ) : (
        <RevisionChatInputForm
          className={'tw-px-6 tw-pb-6'}
          commentMutation={replyCommentMutation}
          replyTarget={{ commentId: replyComment.id, revisionId: replyComment.revision }}
          onSubmit={() => {
            invalidate();
            setTimeout(() => scrollToBottom(), 1);
          }}
        />
      )}
    </>
  );
};

export default RevisionChatCommentReplySheetContent;
